<template>
	<Teleport :to="attach">
		<div class="confirm mdc-dialog"
			role="alertidalog"
			aria-modal="true"
			aria-labelledby="dialog_title"
			area-describedby="dialog_content" ref="dialogRef">
			<div class="mdc-dialog__container">
				<div class="mdc-dialog__surface">
					<h2 class="mdc-dialog__title" id="dialog_title" v-html="options.title"></h2>
					<div class="mdc-dialog__content" id="dialog_content" v-html="options.message"></div>
					<footer class="mdc-dialog__actions">
						<button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="close" @click="options.cancelAction()" v-if="options.showCancel">
							<span class="mdc-button__ripple"></span>
							<span class="mdc-button__label" v-html="options.cancelLabel"></span>
						</button>
						<button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="accept" @click="options.acceptAction()">
							<span class="mdc-button__ripple"></span>
							<span class="mdc-button__label" v-html="options.acceptLabel"></span>
						</button>
					</footer>
				</div>
			</div>
			<div class="mdc-dialog__scrim"></div>
		</div>
	</Teleport>
</template>

<script setup>
// Dependencies
import { MDCDialog } from '@material/dialog'
import { onMounted, ref, watch } from 'vue'
import { emitter } from './index'

const props = defineProps({
	attach: {
		type: String,
		default: `body`,
	},
})

const defaults = {
	title: 'Are you sure?',
	acceptLabel: 'Confirm',
	acceptAction: () => ({}),
	cancelLabel: 'Cancel',
	cancelAction: () => ({}),
	showCancel: true,
}

const options = ref({})
const dialogRef = ref()

onMounted(() => {
	const dialog = new MDCDialog(dialogRef.value)

	emitter.on('show', ({msg, opts}) => {
		options.value = {
			...defaults,
			...opts,
			message: msg,
		}
		dialog.open()
	})

	emitter.on('hide', () => {
		dialog.close()
	})
})
</script>

<style scoped lang="scss">
@use '@material/button';
@use '@material/dialog/mdc-dialog';

.confirm {
	z-index: 99;
}

</style>
